import { createApp } from "vue";
import { createPinia } from "pinia";
import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";
import VMdEditor from "@kangc/v-md-editor";
import "@kangc/v-md-editor/lib/style/base-editor.css";
import githubTheme from "@kangc/v-md-editor/lib/theme/github.js";
import "@kangc/v-md-editor/lib/theme/style/github.css";
import hljs from "highlight.js";
import enUS from "@kangc/v-md-editor/lib/lang/en-US";
VMdEditor.use(githubTheme, {
  Hljs: hljs,
});
VMdEditor.lang.use("en-US", enUS);
import {
  getFirstLetter,
  formatDateTime,
  redirectTo,
  getCountryCode,
} from "@L/helpers";
import router from "./router";
import "./assets/css/app.css";
import App from "./App.vue";
const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(FloatingVue, {
  distance: 10,
});
app.use(VMdEditor);
app.config.globalProperties.$getFirstLetter = getFirstLetter;
app.config.globalProperties.$formatDateTime = formatDateTime;
app.config.globalProperties.$redirectTo = redirectTo;
app.config.globalProperties.$getCountryCode = getCountryCode;
app.mount("#app");
